import React from 'react';
import { LayoutRoute } from 'components/Layout';
import { default as HomePublicaLayout } from 'components/Layout/HomePublica';
import PrivateLayoutRoute from 'components/Layout/PrivateLayoutRoute';
import { DOAsegurado } from 'containers/DO/DOAsegurado';
import { DOContratante } from 'containers/DO/DOContratante';
import { DODatosAsegurado } from 'containers/DO/DODatosAsegurado';
import DOFinPago from 'containers/DO/DOFinPago';
import DOPago from 'containers/DO/DOPago';
import DOPlanes from 'containers/DO/DOPlanes';
import { DOPreguntas } from 'containers/DO/DOPreguntas';
import { DOResumen } from 'containers/DO/DOResumen';
import { DOVigencia } from 'containers/DO/DOVigencia';
import RecuperarCotizacionDO from 'containers/DO/RecuperarCotizacionDO';
import { DO } from 'containers/DO/constantes/general';

const DO_ROUTES = [
  <LayoutRoute
    exact={true}
    path={`${DO.urls.datosAsegurado}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={DODatosAsegurado}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${DO.urls.preguntas}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={DOPreguntas}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${DO.urls.planes}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={DOPlanes}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${DO.urls.resumen}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={DOResumen}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${DO.urls.cliente}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={DOContratante}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${DO.urls.asegurado}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={DOAsegurado}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${DO.urls.vigencia}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={DOVigencia}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${DO.urls.pago}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={DOPago}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${DO.urls.finPago}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={DOFinPago}
    navBarTab="personas"
  />,
  <PrivateLayoutRoute
    exact={true}
    path="/recuperar-cotizacion-do"
    layout={HomePublicaLayout}
    component={RecuperarCotizacionDO}
  />,
];

export default DO_ROUTES;
